import api from '../../api';
import { updateTeacherPeriods } from '../../redux/slices/teacherAccountSlice';

export const quizService = {
    // Get course details with plan
    getFeed: async () => {
        try {
            const response = await api.get(`/students/feed`);
            console.log('FRESH', response)
            return response.data;
        } catch (error) {
            console.error('Error fetching teaching plan:', error);
            throw error;
        }
    },

    getQuiz: async (quizId) => {
        try {
            const response = await api.get(`/quizzes/${quizId}`);
            return response.data;
        } catch (error) {
            console.error('Error updating teaching plan:', error);
            throw error;
        }
    }
};

export default quizService;